import { useState } from "react";
import { normalizeDispatchPeriod } from "../utils/dispatchDateUrls.js";
import { buildOperationalStepReassignmentKey } from "../utils/resultsFleetData.js";

export default function useResultsWorkspacePopoverState({ renderAssignmentCards, workspaceStore }) {
  const [reassignmentPopover, setReassignmentPopover] = useState(null);

  const closeReassignmentPopover = ({ rerender = true } = {}) => {
    const state = workspaceStore.getState();
    if (state && state.openOperationalReassignmentKey !== null) {
      state.openOperationalReassignmentKey = null;
      if (rerender) {
        renderAssignmentCards();
      }
    }

    setReassignmentPopover(null);
  };

  const toggleReassignmentPopover = ({ anchorElement = null, assignmentId = "", stepId = "", stepType = "" } = {}) => {
    const state = workspaceStore.getState();
    if (!state || !assignmentId || !stepId || !stepType || !(anchorElement instanceof HTMLElement)) {
      return;
    }

    const normalizedDispatchPeriod = normalizeDispatchPeriod(
      state.resultsData?.ui_dispatch_period
      || state.resultsData?.dispatch_period,
    );

    const panelKey = buildOperationalStepReassignmentKey(assignmentId, stepId);
    if (state.openOperationalReassignmentKey === panelKey) {
      closeReassignmentPopover({ rerender: true });
      return;
    }

    state.openOperationalReassignmentKey = panelKey;
    renderAssignmentCards();
    setReassignmentPopover({
      anchorElement,
      assignmentId,
      dispatchPeriod: normalizedDispatchPeriod,
      stepId,
      stepType,
    });
  };

  return {
    closeReassignmentPopover,
    reassignmentPopover,
    toggleReassignmentPopover,
  };
}
